import { type FC, useEffect, useState } from 'react';

import { type Builder, type ExternalTool, type PopupQuiz } from '@editor2/types/pageElements';
import { updateElement } from '@editor2/reducers/editor/editorSlice';

import CopyInput from '@editor2/components/CopyInputWrapper';
import CodeMirrorJSON from '@editor2/components/CodeMirrorJSON';

import { elementCommonStyles } from '@editor2/styles/element';
import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';

interface Props {
	element: Builder | PopupQuiz | ExternalTool;
	courseId: number;
}

const JsonConfig: FC<Props> = (props) => {
	const { element, courseId } = props;

	const commonPayload = { elementId: element.family_id, courseId };

	const debouncedDispatch = useDebouncedDispatch();

	const [config, setConfig] = useState(element.config || '');

	useEffect(() => {
		if (element.config !== config) {
			setConfig(element.config);
		}
	}, [element]);

	const handleChange = (value: string) => {
		setConfig(value);
		debouncedDispatch(updateElement({ ...commonPayload, config: value }));
	};

	return (
		<div className={elementCommonStyles}>
			<CopyInput label="Family ID" value={element.family_id} />
			<CodeMirrorJSON value={config} onChange={handleChange} />
		</div>
	);
};

export default JsonConfig;
